import { Injectable } from "@angular/core";
import { PersistedStoreConfig } from '@persistence/persisted-store-config';
import { ID } from "@common/interfaces/id";
import { ISharedResource } from "@common/interfaces/sharedResource";
import { Topics } from "@common/interfaces/topics";
import { EntityState, EntityStore } from "@datorama/akita";

export interface ISharedResourceState extends EntityState<ISharedResource, ID> { }

@Injectable({
  providedIn: 'root'
})
@PersistedStoreConfig({ name: Topics.SHARED_RESOURCES , realtimeEntity: 'SharedResource'})
export class SharedResourceStore extends EntityStore<ISharedResourceState> {
  constructor() {
    super();
  }
}
